import React from "react";
import {COLOR_WARNING} from "../../Colors";

export const Alerta = ({ children, className, style, ...props }) => (
  <div
    className={`col-12 py-2 ${className || ""}`}
    style={{
      ...(style || {}),
      color: COLOR_WARNING,
      fontWeight: 500,
      borderRadius: "4px",
    }}
    {...props}
  >
    {children}
  </div>
);
